import { TenantOpeningDay } from "src/app/backend/models/tenant/tenant";
import { Nullable } from "./nullable";
import { dateUtil } from "src/app/support/date-util";
import dayjs from "dayjs";

export function dateIsWithinRageIncluded({
  startAt,
  endAt,
  date
}: {
  startAt: string;
  endAt: string;
  date: string;
}): boolean {
  return dateUtil(date).isBetween(startAt, endAt, "minute", "[]");
}

export function toISODateOrEmpty(value: Nullable<number>): Nullable<string> {
  if (!value) {
    return null;
  }

  return dateUtil(value).toISOString();
}

export function isToday(value: string): boolean {
  if (!value) {
    return false;
  }

  return dateUtil(value).isToday();
}

export function isStartEndDatesInWokringDaysRanges({
  startDate,
  endDate,
  openings
}: {
  startDate: Date;
  endDate: Date;
  openings?: Array<{
    day: TenantOpeningDay;
    open24Hours?: boolean;
    periods?: Array<{
      startAt: string;
      endAt: string;
    }>;
  }>;
}): boolean {
  if (!openings) {
    return true;
  }
  const day = dayjs(startDate).locale("en").format("dddd").toLowerCase();

  const opening = openings?.find((opening) => opening.day === day);
  if (!opening || opening.open24Hours) {
    return true;
  }

  const cellStartDate = dayjs(startDate);
  const cellEndDate = dayjs(endDate);

  const period = opening?.periods?.find((period) => {
    const periodStartDate = cellStartDate
      .clone()
      .set("hours", dayjs(period.startAt).get("hours"))
      .set("minutes", dayjs(period.startAt).get("minutes"))
      .set("seconds", dayjs(period.startAt).get("seconds"))
      .add(-1, "seconds");

    const periodEndDate = cellEndDate
      .clone()
      .set("hours", dayjs(period.endAt).get("hours"))
      .set("minutes", dayjs(period.endAt).get("minutes"))
      .set("seconds", dayjs(period.endAt).get("seconds"))
      .add(1, "seconds");

    if (
      cellStartDate.isBetween(periodStartDate, periodEndDate) &&
      cellEndDate.isBetween(periodStartDate, periodEndDate)
    ) {
      return true;
    }

    return false;
  });

  return !!period;
}

export function isDateInISODate(value: Nullable<string>): boolean {
  if (!value) {
    return false;
  }
  const regexISO =
    /^\d{4}-[01]\d-[0-3]\d[T\s](?:[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?|[24]\d:[0-5]\d:[0-5]\d(?:\.\d+)?)Z$/;
  return regexISO.test(value);
}

export function stringISOToDate(isoDate: string): Date {
  return dateUtil(isoDate).toDate();
}
